<div class="doYouOwnDevice">
  <p class="doYouOwnDevice__text">
    {{ 'popup-title--' + device() | translate }}
  </p>
  <app-button
    [attr.uid]="'doYouOwnDevice__btn__yes__' + device()"
    color="purple"
    [label]="'owns-device-popup-btn-yes--' + device() | translate"
    (click)="onSelect(true)"
  />
  <app-button
    [attr.uid]="'doYouOwnDevice__btn__no__' + device()"
    color="purple"
    [label]="'owns-device-popup-btn-no--' + device() | translate"
    (click)="onSelect(false)"
  />
</div>
